/* ═══════════════════════════════════════════════════════════════════════════
   aguasdeipanema-megamenu.js — comportamento do mega menu (desktop/notebook)
   MEGA MENU RULE:
   - hover com intenção: abre depois de 140ms, fecha depois de 260ms (sem
     menu nervoso); a ponte CSS + o atraso cobrem o vão até o painel
   - clique: painel fechado → abre (também no touch em largura de desktop);
     painel aberto → o link navega normalmente
   - teclado: foco no item abre; Tab percorre os links; ESC fecha e devolve
     o foco ao item; foco saindo do item fecha
   - só um painel aberto por vez; clique fora e scroll longo fecham
   Os painéis vivem dentro do <li data-aip-mega> gerado em desktop-menu.liquid.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__aipMegaMenu) return;
  window.__aipMegaMenu = true;

  var ABRIR_MS = 140, FECHAR_MS = 260;
  var itens = [], aberto = null;
  var podeHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function painelDe(item) { return item.querySelector('.aip-mm__panel'); }
  function gatilhoDe(item) { return item.querySelector('.aip-mm__trigger'); }

  function abrir(item) {
    if (aberto && aberto !== item) fechar(aberto, true);
    var p = painelDe(item), g = gatilhoDe(item);
    if (!p || !g) return;
    clearTimeout(item.__tFechar);
    if (aberto === item) return;
    aberto = item;
    item.setAttribute('data-aip-aberto', '');
    g.setAttribute('aria-expanded', 'true');
    p.hidden = false;
    /* dois frames: o display muda antes da transição de opacidade */
    requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-aberto'); }); });
  }

  function fechar(item, imediato) {
    var p = painelDe(item), g = gatilhoDe(item);
    if (!p || !g) return;
    clearTimeout(item.__tAbrir);
    clearTimeout(item.__tFechar);
    item.removeAttribute('data-aip-aberto');
    g.setAttribute('aria-expanded', 'false');
    p.classList.remove('is-aberto');
    if (imediato) { p.hidden = true; if (item.__restaurar) item.__restaurar(); }
    else { setTimeout(function () { if (!item.hasAttribute('data-aip-aberto')) { p.hidden = true; if (item.__restaurar) item.__restaurar(); } }, 190); }
    if (aberto === item) aberto = null;
  }

  function fecharTodos(imediato) { itens.forEach(function (i) { if (i.hasAttribute('data-aip-aberto')) fechar(i, imediato); }); }

  function ligar(item) {
    var g = gatilhoDe(item), p = painelDe(item);
    if (!g || !p) return;
    itens.push(item);

    if (podeHover) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(item.__tFechar);
        clearTimeout(item.__tAbrir);
        item.__tAbrir = setTimeout(function () { abrir(item); }, ABRIR_MS);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(item.__tAbrir);
        clearTimeout(item.__tFechar);
        item.__tFechar = setTimeout(function () { fechar(item); }, FECHAR_MS);
      });
    }

    /* clique / toque / Enter no item */
    g.addEventListener('click', function (e) {
      if (item.hasAttribute('data-aip-aberto')) return; /* aberto → navega */
      e.preventDefault();
      abrir(item);
    });

    /* teclado: foco entra abre, foco sai fecha */
    item.addEventListener('focusin', function () {
      if (item.__ignoraFoco) return; /* ESC devolveu o foco ao link: não reabrir */
      clearTimeout(item.__tFechar); abrir(item);
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      fechar(item);
    });
  }

  /* ── Destaques dinâmicos (painel com data-aip-dinamico) ────────────────
     Ao pousar num link de coleção filtrada, busca a mesma URL com
     view=aipmega (templates/collection.aipmega.json) e troca os cards.
     Debounce de 180ms, cache por URL, volta ao padrão quando o painel fecha. */
  var cacheAjax = {};
  function ligarDinamico(item) {
    var p = painelDe(item);
    if (!p || !p.hasAttribute('data-aip-dinamico')) return;
    var wrap = p.querySelector('[data-aip-destaques]');
    var base = p.querySelector('[data-aip-prods-base]');
    var tit = p.querySelector('[data-aip-destaques-titulo]');
    if (!wrap || !base) return;
    var htmlBase = base.innerHTML, titBase = tit ? tit.textContent : '';
    var timer = null, atual = '';
    function aplicar(url, valor, html) {
      if (atual !== url) return;
      base.innerHTML = html;
      if (tit) tit.textContent = (titBase ? titBase + ' · ' : '') + valor;
    }
    function buscar(url, valor) {
      atual = url;
      if (cacheAjax[url]) { aplicar(url, valor, cacheAjax[url]); return; }
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'view=aipmega', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var prods = doc.querySelector('[data-aip-ajax-prods]');
          if (!prods || !prods.children.length) return;
          cacheAjax[url] = prods.innerHTML;
          aplicar(url, valor, prods.innerHTML);
        }).catch(function () {});
    }
    p.querySelectorAll('[data-aip-filtro]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { buscar(a.getAttribute('data-aip-filtro'), a.getAttribute('data-aip-valor') || a.textContent.trim()); }, 180);
      });
      a.addEventListener('mouseleave', function () { clearTimeout(timer); });
      a.addEventListener('focus', function () { buscar(a.getAttribute('data-aip-filtro'), a.getAttribute('data-aip-valor') || a.textContent.trim()); });
    });
    item.__restaurar = function () { clearTimeout(timer); atual = ''; base.innerHTML = htmlBase; if (tit) tit.textContent = titBase; };
  }

  function iniciar() {
    itens = [];
    document.querySelectorAll('[data-aip-mega]').forEach(function (i) { ligar(i); ligarDinamico(i); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !aberto) return;
    var item = aberto, g = gatilhoDe(item);
    fechar(item, true);
    item.__ignoraFoco = true;
    if (g) g.focus();
    setTimeout(function () { item.__ignoraFoco = false; }, 100);
  });
  document.addEventListener('pointerdown', function (e) {
    if (!aberto) return;
    if (aberto.contains(e.target)) return;
    fecharTodos(true);
  });
  /* rolar a página fecha (o header é sticky, o painel iria junto) */
  var ultimoY = window.scrollY;
  window.addEventListener('scroll', function () {
    if (aberto && Math.abs(window.scrollY - ultimoY) > 80) { fecharTodos(); ultimoY = window.scrollY; }
    if (!aberto) ultimoY = window.scrollY;
  }, { passive: true });
  /* o tema recarrega o header no editor */
  document.addEventListener('shopify:section:load', iniciar);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
